export default __webpack_public_path__ + "static/media/ip-addressImg_2.395accae.webp";